import React from "react";
import { connect } from "react-redux";
import { cekCookies } from "../../../../actions";
import accountManagement from "../../../../apis/accountManagement";
import { CONFIG } from "../../../../config";
import Loader from "../../../Loader";
import env from "react-dotenv";

class CetakAkunSiswa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: true,
            dataSiswa: [],
        };
    }

    componentDidMount = async () => {
        const idSiswa = this.props.match.params.idSiswa;
        console.clear();
        if (idSiswa !== "") {
            const resp = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_SEARCH_SISWA_BY_ID_SISWA + idSiswa).catch(function (error) {});
            if (resp) {
                this.setState({
                    isFetching: false,
                    dataSiswa: resp.data.data,
                });
            }
            console.log(resp.data.data);
        }
    };

    render() {
        require("../homework/homeworkReport.css");
        return (
            <div
                className="containerFluid"
                style={{
                    backgroundImage: 'url("https://www.wallpapertip.com/wmimgs/25-255513_gambar-background-spanduk-vector-bliblinews-kumpulan-background-biru.jpg")',
                }}
            >
                {this.state.isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        <div className="row">
                            <table width="100%">
                                <tr>
                                    <td width="20%"></td>
                                    <td width="60%">
                                        <h2 style={{ "place-content": "center" }}>
                                            <b></b>
                                        </h2>
                                    </td>
                                    <td width="20%">
                                        <img src={process.env.REACT_APP_URL_SISWA_FE + "/static/images/eduprime_tulisan_hitam.png"} width="100%" />
                                    </td>
                                </tr>
                            </table>
                            <div className="col-md-9"></div>
                            <div className="col-md-3"></div>
                        </div>
                        <br></br>
                        <div className="row" style={{ "place-content": "center" }}>
                            <h3>
                                <b>
                                    <u>Kartu Akses Siswa</u>
                                </b>
                            </h3>
                        </div>
                        <br></br>
                        <div className="row" style={{ "place-content": "center" }}>
                            <h3>
                                <b>{this.state.dataSiswa.NAMA_SEKOLAH}</b>
                            </h3>
                        </div>
                        <div className="row" style={{ "place-content": "center" }}>
                            <h4>
                                <b>{this.state.dataSiswa.KODE_TAHUN_AJARAN}</b>
                            </h4>
                        </div>
                        <hr style={{ border: "double" }} />

                        {/* DATA SISWA */}
                        <br></br>
                        <div className="row" style={{ "place-content": "center" }}>
                            <table>
                                <tr>
                                    <td width="130px" className="tabel-data-username">
                                        Nama Siswa
                                    </td>
                                    <td width="30px" className="tabel-data-username">
                                        :
                                    </td>
                                    <td className="tabel-data-username">{this.state.dataSiswa.NAMA_SISWA}</td>
                                </tr>
                                <tr>
                                    <td width="130px" className="tabel-data-username">
                                        Kelas
                                    </td>
                                    <td width="30px" className="tabel-data-username">
                                        :
                                    </td>
                                    <td className="tabel-data-username">{this.state.dataSiswa.NAMA_KELAS_PARALEL}</td>
                                </tr>
                                <tr>
                                    <td width="130px" className="tabel-data-username">
                                        Username
                                    </td>
                                    <td width="30px" className="tabel-data-username">
                                        :
                                    </td>
                                    <td className="tabel-data-username">{this.state.dataSiswa.USERNAME_SISWA}</td>
                                </tr>
                                <tr>
                                    <td width="130px" className="tabel-data-username">
                                        Password
                                    </td>
                                    <td width="30px" className="tabel-data-username">
                                        :
                                    </td>
                                    <td className="tabel-data-username">{this.state.dataSiswa.PASSWORD}</td>
                                </tr>
                            </table>
                        </div>
                        <hr style={{ border: "double", "margin-top": "50px" }} />
                        <hr style={{ "margin-top": "270px" }}></hr>
                        <div className="row">
                            {this.state.dataSiswa.PASSWORD !== "-" ? (
                                <div style={{ "margin-left": "20px", color: "black", "text-decoration-line": "underline" }}>
                                    <b>NB. Password diatas adalah password default pada saat generate akun, jika sudah diganti siswa maka sistem tidak bisa menampilkan password tersebut</b>
                                </div>
                            ) : (
                                <div style={{ "margin-left": "20px", color: "black", "text-decoration-line": "underline" }}>
                                    <b>NB. Akun ini adalah akun yang dibuat sendiri (registrasi mandiri), maka password tidak diketahui</b>
                                </div>
                            )}
                        </div>
                    </div>
                )}
                <div className="fixed_button">
                    <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                        Print
                    </button>
                </div>
            </div>
        );
    }
    loading = () => {
        if (this.state.isLoading) {
            return <Loader />;
        }
    };
}

const mapStateToProps = (state) => {
    return {
        account: state.account,
    };
};

export default connect(mapStateToProps, { cekCookies })(CetakAkunSiswa);
